import Alpine from "alpinejs"
import persist from "@alpinejs/persist"
Alpine.plugin(persist)

const DAY_IN_MS = 24 * 60 * 60 * 1000

Alpine.data("notificationToast", function (config = {}) {
    // id: node identifier, keeps the dismissed state separate per toast
    // hideForDays: how long a dismissal lasts, 0 = forever
    // contentUpdatedAt: unix seconds of the last content change
    // forceShow: always show, ignoring the dismissed state (backend)
    const { id = "", hideForDays = 0, contentUpdatedAt = 0, forceShow = false } = config
    const updatedAt = Number(contentUpdatedAt) * 1000

    return {
        // Timestamp (ms) of the moment the visitor closed the toast, 0 = never closed
        dismissedAt: Alpine.$persist(0).as(`notificationToast.${id}.dismissedAt`),

        init() {
            // Bind the scroll listener to correctly reference `this`
            window.addEventListener("scroll", this.handleScroll.bind(this))

            if (forceShow || !this.isDismissed()) {
                this.showNotification()
            } else {
                this.hideNotification()
            }
        },

        // A dismissal expires when the content changed since then, or after `hideForDays`
        isDismissed() {
            if (!this.dismissedAt) {
                return false
            }
            // Editors published a change after the visitor dismissed it, so this is a new notification
            if (this.dismissedAt < updatedAt) {
                return false
            }
            if (!hideForDays) {
                return true
            }
            return Date.now() - this.dismissedAt < hideForDays * DAY_IN_MS
        },

        // Handle the scroll behavior
        handleScroll() {
            if (window.scrollY > 100) {
                this.collapse()
            } else {
                this.expand()
            }
        },

        get open() {
            return this.$refs.notificationToast.open
        },

        showModal() {
            this.$refs.notificationToast.showModal()
        },

        toggle(el) {
            const parent = el.closest("[x-data]")
            if (parent.classList.contains("expanded")) {
                parent.classList.remove("expanded")
                parent.classList.add("collapsed")
            } else {
                parent.classList.remove("collapsed")
                parent.classList.add("expanded")
            }
        },

        closeModal() {
            this.hideNotification()
            this.dismissedAt = Date.now() // Persist when it was dismissed
        },

        collapse() {
            this.$refs.notificationToast.classList.remove("expanded")
            this.$refs.notificationToast.classList.add("collapsed")
        },

        expand() {
            this.$refs.notificationToast.classList.remove("collapsed")
            this.$refs.notificationToast.classList.add("expanded")
        },

        hideNotification() {
            this.$refs.notificationToast.classList.add("hidden")
        },

        showNotification() {
            this.$refs.notificationToast.classList.remove("hidden")
            this.$refs.notificationToast.classList.add("expanded")
        },
    }
})
